import { connect } from "react-redux";
import RTOCaseView from "./View";
import { bindActionCreators } from "redux";
import {caseByIdRequest, caseStatusUpdateRequest, loanApplicationByIdRequest, rcCaseByIdRequest, rtoDetailsUpdateRequest} from "../../../../../../services/redux/CarLoan/action";
import {documentUploadUrlPublic} from "../../../../../../services/redux/fileUpload/action";
const mapStateToProps = (state) => ({
    caseByIdResponse : state.CarLoan.caseByIdResponse,
    caseStatusUpdateResponse : state.CarLoan.caseStatusUpdateResponse,
    loanApplicationByIdResponse : state.CarLoan.loanApplicationByIdResponse,
    rcCaseByIdResponse : state.CarLoan.rcCaseByIdResponse,
    rtoDetailsUpdateResponse : state.CarLoan.rtoDetailsUpdateResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseByIdRequest,
        caseStatusUpdateRequest,
        loanApplicationByIdRequest,
        documentUploadUrlPublic,
        rcCaseByIdRequest,
        rtoDetailsUpdateRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RTOCaseView);